/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolMuseumIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-museum"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M1.2 22.85L1.2 20.2L3.25 20.2L3.25 11.65L3 11.65Q2.25 11.65 1.73 11.11Q1.2 10.57 1.2 9.82Q1.2 9.28 1.45 8.79Q1.7 8.3 2.15 7.97L10.47 2.15Q10.82 1.9 11.21 1.79Q11.6 1.68 12 1.68Q12.4 1.68 12.79 1.79Q13.18 1.9 13.53 2.15L21.85 7.97Q22.3 8.3 22.55 8.79Q22.8 9.28 22.8 9.85Q22.8 10.6 22.27 11.13Q21.75 11.65 21 11.65L20.75 11.65L20.75 20.2L22.8 20.2L22.8 22.85ZM8.88 18.45Q8.88 18.45 9.15 18.45Q9.43 18.45 9.81 18.06Q10.2 17.68 10.2 17.13L10.2 14.7L10.9 15.75Q11.1 16.05 11.39 16.2Q11.68 16.35 12 16.35Q12.32 16.35 12.61 16.2Q12.9 16.05 13.1 15.75L13.8 14.7L13.8 17.13Q13.8 17.68 14.19 18.06Q14.57 18.45 15.13 18.45Q15.68 18.45 16.06 18.06Q16.45 17.68 16.45 17.13L16.45 11.75Q16.45 11.32 16.14 11.01Q15.82 10.7 15.4 10.7L14.47 10.7Q14.2 10.7 13.96 10.82Q13.72 10.95 13.57 11.18L12 13.55L10.47 11.28Q10.3 11 10.03 10.85Q9.75 10.7 9.43 10.7L8.82 10.7Q8.3 10.7 7.92 11.07Q7.55 11.45 7.55 11.97L7.55 17.13Q7.55 17.68 7.94 18.06Q8.32 18.45 8.88 18.45Z" fill={color} />
    </svg>
  );
}
